import { render } from "./ChatThreads.vue?vue&type=template&id=efa69880&scoped=true&ts=true"
import script from "./ChatThreads.vue?vue&type=script&lang=ts"
export * from "./ChatThreads.vue?vue&type=script&lang=ts"

import "./ChatThreads.vue?vue&type=style&index=0&id=efa69880&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efa69880"]])

export default __exports__